export default __webpack_public_path__ + "static/media/erx-delivery-failed-icon.a63ab001.svg";